module.exports = __webpack_public_path__ + "static/media/section-two.69c91d9a.png";